var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},_vm._l((_vm.stars),function(star,index){return _c('div',{key:index,staticClass:"w-1/5"},[_c('icon',{staticClass:"text-yellow-500 w-full h-full",attrs:{"name":star.filled ? 'star-filled' : 'star'}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }